import Vue from 'vue'

const CURRENT_AGB_VERSION = 'v1'
const LOCAL_STORAGE_KEY = 'agb_accepted'

export function termsOfUseAccepted() {
  return localStorage.getItem(LOCAL_STORAGE_KEY) === CURRENT_AGB_VERSION
}

export function clearTermsOfUseAcceptance() {
  localStorage.removeItem(LOCAL_STORAGE_KEY)
}

export async function loadTermsOfUseAcceptanceFromBackend(
  successHandler,
  errorMessageHandler
) {
  await Vue.prototype.$verifiedAPI
    .get('/agb/has_accepted/' + CURRENT_AGB_VERSION)
    .then(
      () => {
        localStorage.setItem(LOCAL_STORAGE_KEY, CURRENT_AGB_VERSION)
        if (typeof successHandler === 'function') {
          successHandler()
        }
      },
      error => {
        localStorage.removeItem(LOCAL_STORAGE_KEY)

        if (error && error.response && error.response.status === 404) {
          console.log('AGB have not been accepted yet')
          return
        }

        console.error('Error getting agb acceptance status', error.response)

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message &&
          typeof errorMessageHandler === 'function'
        ) {
          errorMessageHandler(error.response.data.message)
        }
      }
    )
}

export async function acceptTermsOfUse(successHandler, errorMessageHandler) {
  await Vue.prototype.$verifiedAPI
    .post('/agb/accept/' + CURRENT_AGB_VERSION)
    .then(
      () => {
        console.log('Terms of Use accepted')
        localStorage.setItem(LOCAL_STORAGE_KEY, CURRENT_AGB_VERSION)
        if (typeof successHandler === 'function') {
          successHandler()
        }
      },
      error => {
        console.error('Error setting agb acceptance', error.response)

        if (error.response && error.response.status === 409) {
          if (!termsOfUseAccepted()) {
            loadTermsOfUseAcceptanceFromBackend(successHandler)
          }
          successHandler()
          return
        }

        if (
          error.response &&
          error.response.data &&
          error.response.data.message &&
          typeof errorMessageHandler === 'function'
        ) {
          errorMessageHandler(error.response.data.message)
        }
      }
    )
}



// WEBPACK FOOTER //
// ./src/agb.js